module.exports = __webpack_public_path__ + "media/WelcomeHome.9f9912d5.mp3";